module.exports = __webpack_public_path__ + "static/media/rect-light.50c156dd.svg";